/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type V2022_1KartePlannerCommentMonthlyAmountFragment = { usage: number, upperLimit: number | null };

export const V2022_1KartePlannerCommentMonthlyAmountFragmentDoc = gql`
    fragment V2022_1KartePlannerCommentMonthlyAmount on V2022_1KartePlannerCommentMonthlyAmount {
  usage
  upperLimit
}
    `;